const STORAGE_KEY = 'shopgnd-device-id';

/** Stable browser device id (localStorage UUID). Not hardware-bound. */
export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing?.trim()) return existing.trim();
    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return 'unknown';
  }
}
